import classNames from "classnames";
import getConfig from "next/config";

const {
  publicRuntimeConfig: {
    settings: { websiteName },
  },
} = getConfig();

const isBricoStore = websiteName === "bricostore";

const ProductListConfigureButton = ({ disabled = false }) => {
  const classes = classNames(
    "mt-14px sm:mt-13px py-7px leading-18.2 text-center outline-none text-sm font-medium text-white active:opacity-75 group w-full sm:hover:bg-red-hover sm:focus:bg-red-active",
    {
      // altex/MG unchanged; bricostore → pill + guideline red scale
      "rounded-tr-md rounded-bl-md bg-red-lightdark": !isBricoStore,
      "rounded-full": isBricoStore,
      "bg-red-brand": isBricoStore && !disabled,
      "bg-red-off": isBricoStore && disabled,
      "opacity-25": disabled && !isBricoStore,
      "cursor-not-allowed": disabled,
    }
  );

  return (
    <button className={classes} disabled={disabled}>
      Configureaza
    </button>
  );
};

export default ProductListConfigureButton;
